$(window).scroll(debounce(function () {
  switch (btn_show) {
    case 'after':
      $('.stickyBtn').css({ 'bottom': scrollPercent > btn_appears ? '2.4rem' : '-5.6rem' });
      break;
    case 'include':
      $('.stickyBtn').css({ 'bottom': scrollPercent >= btn_appears && scrollPercent <= (btn_appears + windowHeightPercent) ? '2.4rem' : '-5.6rem' });
      break;
    default:
      $('.stickyBtn').css({ 'bottom': scrollPercent < btn_appears || scrollPercent > (btn_appears + windowHeightPercent) ? '2.4rem' : '-5.6rem' });
      break;
  }
}))